const PREFIX = 'DASHBOARD';

export const GET_DASHBOARD = `${PREFIX}/GET`;
export const GET_WIDGET_INFO = `${PREFIX}/GET_WIDGET`;
export const CLEAR_WIDGETS = `${PREFIX}/CLEAR_WIDGETS`;
export const LIST_BIRTHDAYS_DASHBOARD = `${PREFIX}/LIST_BIRTHDAYS`;
export const LIST_DASHBOARD_BY_ROLE = `${PREFIX}/LIST_BY_ROLE`;
